export const sentryConfig = {
    release: process.env.APP_VERSION,
    server: {
        traceSampleRate: 0.005,
        errorSampleRate: 0.005,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0.35,
        logLevel: "error",
    },
    client: {
        traceSampleRate: 0.005,
        errorSampleRate: 0.005,
        replaysSessionSampleRate: 0,
        replaysOnErrorSampleRate: 0.35,
        logLevel: "error",
        navigationLogLevel: "error",
        clickLogLevel: "error"
    },
}